module.exports = __webpack_public_path__ + "static/media/RoastTable.e6da2ac4.png";